module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"manage_users":"UTILISATEURS","add":"Ajouter","find":"Rechercher","close":"Fermer","no_available_user":"Aucun utilisateur disponible pour être ajouté"},"en":{"manage_users":"USERS","add":"Add","find":"Find","close":"Close","no_available_user":"No user available to add"}}')
  delete Component.options._Ctor
}
